import { useAppContext } from 'hooks/context/useAppContext';

export const usePreferences = () => {
  const { publicUser } = useAppContext();

  const {
    preferences: {
      gift_card_purchase_enabled: areGiftCardsEnabled,
      show_client_reviews: showClientReviews,
      fixed_location_preference: isFixedLocation,
      housecall_location_preference: doesHouseCalls,
      ask_for_pronouns: askForPronouns,
      brand_color_override_primary: brandColorPrimaryOverride,
      prompt_contact_on_booking_denial: promptForContactOnBooking,
      visual_service_menu: isVisualServiceMenu,
      online_booking_disabled: isOnlineBookingDisabled,
      review_with_google_url: reviewWithGoogleUrl,
      allow_review_with_google: allowReviewWithGoogle,
      allow_bnpl_payment_method: allowBnplPaymentMethod,
      show_bnpl_prices_in_booking_site: showBNPLPrices,
      redact_pii_from_notifications: redactPiiFromNotifications,
    },
  } = publicUser ?? { preferences: {} };

  return {
    areGiftCardsEnabled,
    showClientReviews,
    isFixedLocation,
    doesHouseCalls,
    askForPronouns,
    brandColorPrimaryOverride,
    promptForContactOnBooking,
    isListView: !isVisualServiceMenu,
    isOnlineBookingDisabled,
    reviewWithGoogleUrl,
    allowReviewWithGoogle,
    allowBnplPaymentMethod,
    showBNPLPrices: allowBnplPaymentMethod && showBNPLPrices,
    redactPiiFromNotifications,
  };
};
